import React, { useState } from "react"
import { OptionButton } from "./option-button"
import { CustomInput } from "./custom-input"
import { getInitialOption } from "../../layout/components/get-initial-option"

const SIZES = {
  none: 0,
  normal: 1,
  large: 4
}

export function BorderSize({ properties, update }) {
  const [sizeOption, setSizeOption] = useState(
    getInitialOption(
      properties,
      [
        "borderTopWidth",
        "borderRightWidth",
        "borderBottomWidth",
        "borderLeftWidth"
      ],
      SIZES
    )
  )

  function handleChange(option, value) {
    if (option !== "custom") {
      setSizeOption(option)
    }

    const newProperties =
      option === "custom"
        ? value
        : {
            borderTopWidth: SIZES[option],
            borderRightWidth: SIZES[option],
            borderBottomWidth: SIZES[option],
            borderLeftWidth: SIZES[option]
          }
    update(newProperties, {
      localStoragePrefix: `layout-${properties.template}`
    })
  }

  return (
    <div>
      <div className="font-semibold text-gray-700 mb-1">Border width</div>
      <div className="flex border rounded mb-2">
        <div className="p-1 flex items-center justify-center flex-grow border-r">
          <OptionButton
            active={sizeOption === "none"}
            onClick={() => handleChange("none")}
          >
            None
          </OptionButton>
          <OptionButton
            active={sizeOption === "normal"}
            onClick={() => handleChange("normal")}
          >
            Normal
          </OptionButton>
          <OptionButton
            active={sizeOption === "large"}
            onClick={() => handleChange("large")}
          >
            Large
          </OptionButton>
        </div>
        <div className="p-1 flex items-center justify-center">
          <OptionButton
            active={sizeOption === "custom"}
            onClick={() => setSizeOption("custom")}
          >
            Custom
          </OptionButton>
        </div>
      </div>

      {sizeOption === "custom" && (
        <div className="grid grid-cols-2 gap-2">
          <CustomInput
            label="Top"
            value={properties.borderTopWidth}
            onChange={value =>
              handleChange("custom", { borderTopWidth: value })
            }
          />

          <CustomInput
            label="Right"
            value={properties.borderRightWidth}
            onChange={value =>
              handleChange("custom", { borderRightWidth: value })
            }
          />

          <CustomInput
            label="Bottom"
            value={properties.borderBottomWidth}
            onChange={value =>
              handleChange("custom", { borderBottomWidth: value })
            }
          />

          <CustomInput
            label="Left"
            value={properties.borderLeftWidth}
            onChange={value =>
              handleChange("custom", { borderLeftWidth: value })
            }
          />
        </div>
      )}
    </div>
  )
}
